import React, { useState } from "react";
import { Button } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import pdfMake from "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import parser from "../../../../shared/helpers/parser";
import Utils from "../../../../shared/helpers/utils";

const ExportTrabajadoresPDF = ({ filteredTrabajadores, establecimientosEmpresa, anexoi, anexov, cuit }) => {
  const [loading, setLoading] = useState(false);

  const getEstablecimiento = (id) => {
    if (!anexoi?.EstablecimientosDeclarados) return null;
    return anexoi.EstablecimientosDeclarados.find(x => x.IdEstablecimientoEmpresa == id);
  };

  const downloadPDF = () => {
    setLoading(true);
    setTimeout(() => {
    const today = new Date();
    const formattedDate = today.toLocaleString(undefined, { hour12: false });

    // --- Tabla principal de trabajadores ---
    const trabajadoresTableBody = [
      [
        { text: 'Id', bold: true, fillColor: '#1890ff', color: '#fff' },
        { text: 'Establecimiento Empresa', bold: true, fillColor: '#1890ff', color: '#fff' },
        { text: 'CUIL', bold: true, fillColor: '#1890ff', color: '#fff' },
        { text: 'Fecha Ingreso', bold: true, fillColor: '#1890ff', color: '#fff' },
      ]
    ];

    (filteredTrabajadores || []).forEach(t => {
      trabajadoresTableBody.push([
        { text: String(t.IdTrabajador ?? ''), fontSize: 8 },
        { text: String(Utils.getIdDesc(t.IdEstablecimientoEmpresa, establecimientosEmpresa) ?? ''), fontSize: 8 },
        { text: String(t.Cuil ?? ''), fontSize: 8 },
        { text: parser.date(t.FechaIngreso), fontSize: 8 },
      ]);
    });

    // --- Secciones de actividades por trabajador ---
    const actividadesSections = [];

    (filteredTrabajadores || []).forEach(t => {
      if (!t.Actividades || t.Actividades.length === 0) return;

      const establecimiento = getEstablecimiento(t.IdEstablecimientoEmpresa);
      const puestos = establecimiento?.Puestos || [];
      const sectores = establecimiento?.Sectores || [];
      const sustancias = anexov?.Sustancias || [];

      actividadesSections.push({
        text: `Actividades - Trabajador ${t.IdTrabajador ?? ''} (CUIL: ${t.Cuil ?? ''})`,
        bold: true,
        fontSize: 10,
        margin: [0, 15, 0, 5],
      });

      const actividadesBody = [
        [
          { text: 'Id', bold: true, fillColor: '#ffa940', color: '#fff', fontSize: 7 },
          { text: 'Puesto Declarado', bold: true, fillColor: '#ffa940', color: '#fff', fontSize: 7 },
          { text: 'Sector Declarado', bold: true, fillColor: '#ffa940', color: '#fff', fontSize: 7 },
          { text: 'Permanente', bold: true, fillColor: '#ffa940', color: '#fff', fontSize: 7 },
          { text: 'Sustancia Declarada', bold: true, fillColor: '#ffa940', color: '#fff', fontSize: 7 },
          { text: 'Fecha Inicio Exposicion', bold: true, fillColor: '#ffa940', color: '#fff', fontSize: 7 },
          { text: 'Fecha Fin Exposicion', bold: true, fillColor: '#ffa940', color: '#fff', fontSize: 7 },
        ]
      ];

      t.Actividades.forEach(a => {
        const idActividad = typeof a.IdActividad === 'object'
          ? (a.IdActividad?.IdActividad || JSON.stringify(a.IdActividad))
          : (a.IdActividad ?? '');

        actividadesBody.push([
          { text: String(idActividad), fontSize: 7 },
          { text: String(Utils.getIdDesc(a.IdPuestoDeclarado, puestos) ?? ''), fontSize: 7 },
          { text: String(Utils.getIdDesc(a.IdSectorDeclarado, sectores) ?? ''), fontSize: 7 },
          { text: a.Permanente === true ? 'Si' : 'No', fontSize: 7 },
          { text: String(Utils.getIdDesc(a.IdSustanciaDeclarada, sustancias) ?? ''), fontSize: 7 },
          { text: parser.date(a.FechaInicioExposicion), fontSize: 7 },
          { text: parser.date(a.FechaFinExposicion), fontSize: 7 },
        ]);
      });

      actividadesSections.push({
        table: {
          headerRows: 1,
          widths: ['auto', '*', '*', 'auto', '*', 'auto', 'auto'],
          body: actividadesBody,
        },
        layout: {
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
          hLineColor: () => '#cccccc',
          vLineColor: () => '#cccccc',
        },
      });
    });

    // --- Documento ---
    const documentDefinition = {
      pageOrientation: 'landscape',
      pageMargins: [30, 50, 30, 30],
      content: [
        {
          text: 'Listado de Trabajadores',
          bold: true,
          fontSize: 18,
          alignment: 'center',
          margin: [0, 0, 0, 5],
        },
        {
          columns: [
            { text: `CUIT: ${cuit || ''}`, fontSize: 10, alignment: 'left' },
            { text: `Fecha de generacion: ${formattedDate}`, fontSize: 10, alignment: 'right' },
          ],
          margin: [0, 0, 0, 10],
        },
        {
          canvas: [{ type: 'line', x1: 0, y1: 0, x2: 760, y2: 0, lineWidth: 0.5 }],
          margin: [0, 0, 0, 10],
        },
        {
          columns: [
            { text: 'Trabajadores', bold: true, fontSize: 12 },
            { text: `Total: ${(filteredTrabajadores || []).length}`, fontSize: 10, alignment: 'right', margin: [0, 2, 0, 0] },
          ],
          margin: [0, 0, 0, 5],
        },
        {
          table: {
            headerRows: 1,
            widths: ['auto', '*', 'auto', 'auto'],
            body: trabajadoresTableBody,
          },
          layout: {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5,
            hLineColor: () => '#cccccc',
            vLineColor: () => '#cccccc',
          },
        },
        ...actividadesSections,
      ],
      footer: (currentPage, pageCount) => ({
        columns: [
          { text: `Pagina ${currentPage} de ${pageCount}`, alignment: 'left', fontSize: 8, margin: [30, 0, 0, 0] },
          { text: `Impreso: ${formattedDate}`, alignment: 'right', fontSize: 8, margin: [0, 0, 30, 0] },
        ],
      }),
    };

    pdfMake.createPdf(documentDefinition).download(`trabajadores_${cuit || 'export'}.pdf`, () => {
        setLoading(false);
      });
    }, 0);
  };

  return (
    <Button
      onClick={downloadPDF}
      type="primary"
      icon={<FilePdfOutlined />}
      loading={loading}
    >
      Exportar PDF
    </Button>
  );
};

export default ExportTrabajadoresPDF;
